import React, { Component } from "react";
import PDF from "../CommonPDF/PDF";
import "./RevenueMaster.css";
import "./RevenueTable.css";

import { Input, notification } from "antd";

import Paper from "@material-ui/core/Paper";
import Pdf from "../../Images/pdf.svg";
import Print from "../../Images/print.svg";
import Excel from "../../Images/excel.svg";
import Logo from "../../Images/tomSvg.svg";
import more from "../../Images/more.svg"
import Tablecomponent from "../../helpers/TableComponent/TableComp";
import DateRangeSelect from "../../helpers/DateRange/DateRange";
import ReactToPrint from "react-to-print";
// import ReactExport from "react-data-export";
import PrintData from "./PrintData";
import { ReactSVG } from "react-svg";
import jsPDF from "jspdf";
import "jspdf-autotable";
import axiosInstance from "../../api/axiosInstance";
import { apiurl, formatMoney } from "../../App";
import dateFormat from "dateformat";
import VisibilityIcon from "@material-ui/icons/Visibility";
import ProfileView from "../TotalOrders/ProfileView";
import Filter from '../../Images/filter.svg';
import AdvanceFilter from "../AdvanceFillter/AdvanceFilter";
import PrescriptionDetailView from "../PrescriptionDetailView/PrescriptionDetailView";
// import PrescriptionDetailView from "../PrescriptionEntry/";
import { withTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Monthpicker from "./mothpicker/Monthpicker";
import moment from "moment";
import logo from "../../Images/logos.png"
import DateData from "./DateData";
import downloadExcel from "../CommonExcel/Excel"
import { type } from "@amcharts/amcharts5";
// const ExcelFile = ReactExport.ExcelFile;
// const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

const headRows = [
  { id: "sno", label: "S.No", Columnwidth: 5 ,typeDt:'sno'},
  { id: "payment_date", label: "Date", type: 'date', Columnwidth: 10 ,typeDt:'date'},
  { id: "name", label: "Member", Columnwidth: 30,typeDt:'str' },
  { id: "unit", label: "Medicine Unit", Columnwidth: 25 },
  { id: "fee", label: "fee", Columnwidth: 12,type: 'amt',typeDt:'amt' },
  { id: "tomShare", label: "Platform Fee", Columnwidth: 12, type: 'amt', typeDt: 'amt' },
  { id: "inCome", label: "Income", Columnwidth: 12, type: 'amt', typeDt: 'amt' },

];
class RevenueMaster extends Component {
  constructor(props) {

    super(props);
    this.getMemberDetails = this.getMemberDetails.bind(this);
    // this.onSearch = this.onSearch.bind(this);
    this.state = {
      isMedListPage: false,
      isMedPage: false,
      initalPage: false,
      medListID: 0,
      props_loading: true,

      tableData: [],
      revenueTotal: 0,
      revenueTomshare: 0,
      revenueFee: 0,
      search: null,
      fromDate: "",
      toDate: "",
      StartDate: "",
      // EndDate:"",
      openview: false,
      prescriptionId: null,
      open_filter: false,
      prescriptionopenview: false,
      selected_doctor_id: 0,
      prescriptionEntryData: null,
      isonclickMember: false,
      isMemberId: 0,
      idControl: '',
      medlistTitle: "",
      startDate: "",
      EndDate: "",
      toggle_Revenue: 'switch',
      toggle_settlement: '',
      pgNav: ''
    };
  }

  componentDidMount() {
    this.handleRouteChange();
  }



  handleRouteChange() {
    const { match } = this.props;
    const { id, startDate, endDate, pageN } = match.params;
    // this.setState({idControl: id,EndDate:endDate,StartDate:startDate})

    var startDate_New = DateData.item.startDate;
    var EndDate_New = DateData.item.endDate;
    // debugger
    if (startDate_New !== '' && EndDate_New !== '') {
      DateData.setdate(DateData.item.startDate, DateData.item.endDate, pageN, this.state.idControl)
      this.setState({
        idControl: (new Date(startDate_New).getMonth() === new Date(EndDate_New).getMonth()
          ? 'settlementkw' : id), EndDate: moment(EndDate_New).endOf('month').format('YYYY-MM-DD'), StartDate: DateData.item.startDate
      })
    } else {
      DateData.setdate(this.state.StartDate, this.state.EndDate, pageN, this.state.idControl)
      this.setState({
        idControl: (new Date(startDate).getMonth() === new Date(endDate).getMonth()
          ? 'settlementkw' : id), EndDate: endDate, StartDate: startDate
      })
    }
    if (id && id != 'settlementkw' && id != 'settlement' && id != "0") {
      let name = "";
      // this.props.match.params.startDate=this.state.startDate
      // DateData.setdate(this.state.StartDate,this.state.EndDate,false,this.state.idControl)

      // this.getRevenueMedList();


      if (this.state.tableData.length > 0) {
        let data = this.state.tableData.filter((val) => val.id === id);
        if (data.length > 0) name = data[0].name;
      }
      this.setState({ isMedListPage: true, medListID: id, medlistTitle: name }, () => this.getRevenueMedList());
    } else {
      this.setState(
        {
          isMedListPage: false,
          // EndDate: endDate,
          // StartDate: startDate,
        },
        () => this.getRevenueData()

      );
      // DateData.setdate(startDate,endDate,'false',0)
    }
    //   let name="";
    //   if(this.state.tableData.length > 0){
    //     let data = this.state.tableData.filter((val) => val.id === id);
    //     if(data.length > 0) name = data[0].name;
    //     debugger
    //   }
    // this.setState({ isMedListPage: true, medListID: id, EndDate:endDate,StartDate:startDate,medlistTitle:name }, () => this.getRevenueMedList());
    // } else {
    // this.setState({ isMedListPage: false, EndDate:endDate,StartDate:startDate  }, () => this.getRevenueData());

    // }
  }

  onSearch(event) {
    this.setState({ search: event.target.value || null });
  }

  getMemberDetails(newState) {
    const { memberID, isOnclickMember } = newState;

    this.setState({
      isonclickMember: isOnclickMember,
      isMemberId: memberID,
    });
  }


  getRevenueData = () => {
    var dateCheck = DateData.item.pagenav
    if (dateCheck == "false" || dateCheck == false) {

      this.setState({
        props_loading: true,
        isMedListPage: false,
        isMedPage: true
      });
      var totalAmount = 0;
      var totaltomshare = 0;
      var totalFee = 0;
      var obj_data = {
        "pharmacyId": localStorage.getItem('pharmacy_id'),
        "fromDate": this.state.StartDate,
        "toDate": this.state.EndDate,
        "filterValue": "",
        "searchElement": ""
      };
      // debugger
      axiosInstance({
        method: "POST",
        url: apiurl + "pharmacy/getPharmacyRevenueList",
        data: obj_data,
      })
        .then((response) => {
          if (response.data.status == 1) {
            if (response.data.data.length > 0) {
              totalAmount = response.data.data
                .map((item) => item.inCome)
                .reduce((acc, curr) => acc + curr, 0);
              totaltomshare = response.data.data
                .map((item) => item.tomShare)
                .reduce((acc, curr) => acc + curr, 0);
              totalFee = response.data.data
                .map((item) => item.fee)
                .reduce((acc, curr) => acc + curr, 0);
              this.setState({
                props_loading: false,
                tableData: response.data.data,
                // enableSearch: false,
                revenueTotal: totalAmount,
                revenueTomshare: totaltomshare,
                revenueFee: totalFee,
              });
              DateData.setdate(this.state.StartDate, this.state.EndDate, false, this.state.idControl)
            } else {
              this.setState({
                props_loading: false,
                tableData: [],
                revenueTotal: 0,
                revenueTomshare: 0,
                revenueFee: 0,
              });
              DateData.setdate(this.state.StartDate, this.state.EndDate, false, this.state.idControl)
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      DateData.setdate(this.state.StartDate, this.state.EndDate, false, this.state.idControl)
    }
  };

  getRevenueMedList = async () => {

    this.setState({
      props_loading: true,
      // isMedListPage:true,
      // initalPage:true
    });
    var totalAmount = 0;
    var totaltomshare = 0;
    var totalFee = 0;
    var obj_data = {
      "prescriptionId": this.state.medListID,
      "searchElement": ""
    };
    await axiosInstance({
      method: "POST",
      url: apiurl + "pharmacy/getPharmacyMedList",
      data: obj_data,
    })
      .then((response) => {
        if (response.data.status == 1) {
          if (response.data.data.length > 0) {
            totalAmount = response.data.data.map(item => item.pharmacyShare).reduce((acc, curr) => acc + curr, 0);
            totaltomshare = response.data.data.map(item => item.tomShare).reduce((acc, curr) => acc + curr, 0);
            totalFee = response.data.data.map(item => item.amount).reduce((acc, curr) => acc + curr, 0);

            this.setState({
              props_loading: false,
              tableData: response.data.data,
              // enableSearch: false,
              revenueTotal: totalAmount,
              revenueTomshare: totaltomshare,
              revenueFee: totalFee,
              idControl: 'settlementkw'
            });
          } else {
            this.setState({
              props_loading: false,
              tableData: [],
              revenueTotal: 0,
              revenueTomshare: 0,
              revenueFee: 0,
              idControl: 'settlementkw'
            });
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getRangeDate = (item) => {
    this.setState(
      {
        StartDate: dateFormat(item[0].startDate, "yyyy-mm-dd"),
        EndDate: dateFormat(item[0].endDate, "yyyy-mm-dd"),
        // fromDate: dateFormat(item[0].startDate, "yyyy-mm-dd"),
        // toDate: dateFormat(item[0].endDate, "yyyy-mm-dd"),
        idControl: 'settlementkw'
      },

      () =>
        // this.state.isMedListPage ? this.getRevenueMedList() : 
        this.getRevenueData()
    );
    DateData.setdate(dateFormat(item[0].startDate, "yyyy-mm-dd"), dateFormat(item[0].endDate, "yyyy-mm-dd"), false, this.state.idControl)
  };

  // data has empty this alert msg showed print pdf excel   
  Notification = () => {
    notification.warning({
      message: "No data found",
      placement: "topRight",
    });
  };


  // PDF FUNCTION
  generatepdf = () => {
    if (this.state.tableData.length === 0) {
      notification.warning({
        message: "No data found",
        placement: "topRight",
      });
    } else {
      const doc = new jsPDF("a4");
      var imagesssdata = "data:image/png;base64,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"
      doc.addImage(imagesssdata, 'JPEG', 15, 15, 20, 25);
      var bodydata = [];
      this.state.tableData.map((data, index) => {
        if (this.state.isMedListPage) {
          bodydata.push([
            index + 1,
            data.medicine_name,
            data.amount,
            data.quantity,
            data.commission_percentage,
            data.tomShare,
            data.pharmacyShare,
          ]);
        } else {
          bodydata.push([
            { content: index + 1, styles: { halign: "center" } },
            {
              content: dateFormat(data.book_date, "d-mmm-yy")
                ? dateFormat(data.book_date, "d-mmm-yy")
                : "-",
              styles: { halign: "center" },
            },
            {
              content: data.name ? data.name : "-",
              styles: { halign: "center" },
            },
            {
              content: data.roomType ? data.roomType : "-",
              styles: { halign: "center" },
            },
            {
              content: data.rate ? data.rate : "-",
              styles: { halign: "center" },
            },
            {
              content: data.tomShare ? data.tomShare : "-",
              styles: { halign: "center" },
            },
            {
              content: data.income ? data.income : "-",
              styles: { halign: "center" },
            },
          ]);
        }

      });
      const bodyStyles = {
        lineWidth: 0.3,
        halign: 'center', // Align content to the center horizontally
      };

      doc.autoTable({
        beforePageContent: function (data) {
          doc.setTextColor(81, 15, 48);
          doc.text("Revenue Details", 14, 43); // 15,13 for css
        },
        margin: { top: 50 },
        showHead: "everyPage",
        theme: "grid",
        head: this.state.isMedListPage ? [[
          { content: "S.No", styles: { fillColor: [81, 15, 48], textColor: 255, fontStyle: "bold", halign: "start" } },
          { content: "Medicine Name", styles: { fillColor: [81, 15, 48], textColor: 255, fontStyle: "bold", halign: "start" } },
          { content: `Fee (${"₹"})`, styles: { fillColor: [81, 15, 48], textColor: 255, fontStyle: "bold", halign: "start" } },
          { content: "Quantity", styles: { fillColor: [81, 15, 48], textColor: 255, fontStyle: "bold", halign: "start" } },
          { content: "Incentive (%)", styles: { fillColor: [81, 15, 48], textColor: 255, fontStyle: "bold", halign: "start" } },
          { content: `Platform Fee (${"₹"})`, styles: { fillColor: [81, 15, 48], textColor: 255, fontStyle: "bold", halign: "start" } },
          { content: `Income (${"₹"})`, styles: { fillColor: [81, 15, 48], textColor: 255, fontStyle: "bold", halign: "start" } }]]
          :
          [[
            { content: "S.No", styles: { fillColor: [81, 15, 48], textColor: 255, fontStyle: "bold", halign: "start" } },
            { content: "Date", styles: { fillColor: [81, 15, 48], textColor: 255, fontStyle: "bold", halign: "start" } },
            { content: "Member", styles: { fillColor: [81, 15, 48], textColor: 255, fontStyle: "bold", halign: "start" } },
            { content: "Medicine Unit", styles: { fillColor: [81, 15, 48], textColor: 255, fontStyle: "bold", halign: "start" } },
            { content: `fee (${"₹"})`, styles: { fillColor: [81, 15, 48], textColor: 255, fontStyle: "bold", halign: "start" } },
            { content: `Platform Fee (${"₹"})`, styles: { fillColor: [81, 15, 48], textColor: 255, fontStyle: "bold", halign: "start" } },
            { content: `Income (${"₹"})`, styles: { fillColor: [81, 15, 48], textColor: 255, fontStyle: "bold", halign: "start" } }]
          ],
        body: bodydata,
        bodyStyles: { cellStyles: bodydata.map(row => row.map(cell => cell ? cell.styles || bodyStyles : "")), lineWidth: 0.3 },
      });

      doc.save("Revenue_Details.pdf");
    }
  };


  
  searchChange = (e) => {
    this.setState({
      search: e.target.value,
    });
  };

  modelopen = (data, id) => {
    if (data === "view") {
      let prescriptionEntryData = this.state.tableData.filter((val) => val.id === id)//prescription_id
      if (prescriptionEntryData.length > 0 && !prescriptionEntryData.medicines) {
        prescriptionEntryData[0].medicines = []
      }

      this.setState({
        prescriptionEntryData, prescriptionopenview: true
      }, () => {

      });
    }
  };
  newDateGet = (startDate, endDate) => {
    DateData.setdate(startDate, endDate, false, this.state.idControl)
  };

  handleClose = () => {
    this.setState({ prescriptionopenview: false, prescription_id: null });
  };

  openAdvanceFilter = () => {
    this.setState({ open_filter: true })
  }
  closeAdvanceFilter = () => {
    this.setState({ open_filter: false })
  }
  handleRadioChange = (event) => {
    const toggle = event.target ? event.target.value : event;
    const { history } = this.props;
    if (toggle == "revenue") {
      this.setState({
        toggle_Revenue: 'switch',
        toggle_settlement: '',
      });
      history.push(
        //  `/home/revenueChart/revenue/2024-01-01/2024-01-31/0`
      );
    } else if (toggle == "settlement") {
      this.setState({
        toggle_Revenue: '',
        toggle_settlement: 'switch',

      });
      history.push(
        `/home/revenueChart/settlement/${this.state.StartDate ? this.state.StartDate : 0}/${this.state.EndDate ? this.state.EndDate : 0}/${this.state.idControl ? this.state.idControl : 0}`
        // `/home/revenueChart/settlement/${this.state.startDate}/${this.state.EndDate}/recsof`
      );
    }
    // this.setState({ TableType: toggle }, () => this.getSettlemetList(toggle));
  };

  getTableData = () => {
    this.setState({ props_loading: true });
    axiosInstance({
      method: "POST",
      url: apiurl + "pharmacy/getPharamacyRevenue",
      data: {
        pharmacy_id: localStorage.getItem("pharmacy_id") || 0,
        prescription_date: this.state.fromDate || "",
        prescription_date_to: this.state.toDate || "",
        doctor_id: this.state.selected_doctor_id || 0,
      },
    })
      .then((response) => {
        const result = response?.data?.data?.result || response?.data?.data || [];
        const tableData = [];
        let totalAmount = 0;
        result.forEach((val) => {
          tableData.push({
            orderId: val.custom_order_id,
            customer: val.customer,
            doctorName: val.doctor_name,
            clinicName: val.clinic_name,
            date: dateFormat(val.approval_date, "dd-mmm-yy"),
            totalCharge: val.total_amount,
            id: val.patient_id,
            prescription_id: val.prescription_id,
            pharmacyId: localStorage.getItem("pharmacy_id") || 0,
            order_id: val.order_id,
          });
          totalAmount += Number(val.total_amount) || 0;
        });
        this.setState({ props_loading: false, tableData, revenueTotal: totalAmount });
      })
      .catch((error) => {
        this.setState({ props_loading: false });
        console.error("getTableData error:", error);
      });
  }

  submitAdvanceFilter = (selected_doctor_id) => {
    this.setState({ selected_doctor_id, open_filter: false }, () => {
      this.getTableData();
    })
  }

  render() {
    const { Search } = Input;
    const { t } = this.props;
    // const heading = ((localStorage.pharmacy_language == 'ar') ? [
    //   { id: "inCome", label: (<span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{`${t("tbl_head_income_with(kwd)")} `}</span>), typeDt: 'amt' },
    //   { id: "tomShare", label: (<span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '2px' }}>{`${t("tbl_head_tomshare")} `}<img style={{ width: '23px', height: '8px' }} src={logo} /></span>), typeDt: 'amt' },
    //   { id: "fee", label: (<span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{`${t("tbl_head_fees_with(kwd)")} `} </span>), typeDt: 'amt' },
    //   { id: "unit", label: t("tbl_head_medicine_unit"), typeDt: 'amt' },
    //   { id: "name", label: (<span style={{ display: 'flex', justifyContent: 'end' }}>{t("tbl_head_member")}</span>), typeDt: 'str' },
    //   { id: "payment_date", label: (<span style={{ display: 'flex', justifyContent: 'center' }}>{t("tbl_head_ticket_date")}</span>), typeDt: 'date' },
    //   { id: "sno", label: t("tbl_head_s_no"), typeDt: 'sno' },
    // ] : [
    //     { id: "sno", label: (<span style={{ display: 'flex', justifyContent: 'start' }}>{t("tbl_head_s_no")}</span>), typeDt: 'sno' },
    //     { id: "payment_date", label: (<span style={{ display: 'flex', justifyContent: 'center' }}>{t("tbl_head_ticket_date")}</span>), typeDt: 'date' },
    //     { id: "name", label: (<span style={{ display: 'flex', justifyContent: '' }}>{t("tbl_head_member")}</span>), typeDt: 'str' },
    //     { id: "unit", label: (<span style={{ display: 'flex', justifyContent: 'center' }}>{t("tbl_head_medicine_unit")}</span>), typeDt: 'amt' },
    //     { id: "fee", label: (<span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{`${t("tbl_head_fees")} `} </span>), typeDt: 'amt' },
    //     { id: "tomShare", label: (<span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '2px' }}><img style={{ width: '23px', height: '8px' }} src={logo} />{`${t("tbl_head_tomshare")} `}</span>), typeDt: 'amt' },
    //     { id: "inCome", label: (<span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{`${t("tbl_head_income")} `}</span>), typeDt: 'amt' },
    //   // { id: "action", label: t("tbl_head_income_with_kwd") },
    // ]);

    const heading = ((localStorage.pharmacy_language == 'ar') ? [
      { id: "inCome", label: t("tbl_head_income_with(kwd)"), typeDt: 'amt' },
      { id: "tomShare", label: t("tbl_head_tomshare"), typeDt: 'amt' },
      { id: "fee", label: t("tbl_head_fees"), typeDt: 'amt' },
      { id: "unit", label: t("tbl_head_medicine_unit"), typeDt: 'int' },
      { id: "name", label: t("tbl_head_member"), typeDt: 'str' },
      { id: "payment_date", label: t("tbl_head_ticket_date"), typeDt: 'date' },
      { id: "sno", label: t("tbl_head_s_no"), typeDt: 'sno' },
    ] : [
        { id: "sno", label: t("tbl_head_s_no"), typeDt: 'sno' },
        { id: "payment_date", label: t("tbl_head_ticket_date"), typeDt: 'date' },
        { id: "name", label: t("tbl_head_member"), typeDt: 'str' },
        { id: "unit", label: t("tbl_head_medicine_unit"), typeDt: 'int' },
        { id: "fee", label: t("tbl_head_fees"), typeDt: 'amt' },
        { id: "tomShare", label: t("tbl_head_tomshare"), typeDt: 'amt' },
        { id: "inCome", label: t("tbl_head_income"), typeDt: 'amt' },
    ]);
    const medListheading = ((localStorage.pharmacy_language == 'ar') ? [
      { id: "pharmacyShare", label: t("tbl_head_income_with_kwd") },
      { id: "tomShare", label: t("tbl_head_tomshare_with_kwd") },
      { id: "commission_percentage", label: t("incentive_percentage") },
      { id: "quantity", label: t("qty") },
      { id: "amount", label: (<span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{`${t("tbl_head_fees_with_kwd")} `}</span>) },
      { id: "medicine_name", label: t("tbl_medicine_name") },
      { id: "sno", label: t("tbl_head_s_no") },
    ] : [
      { id: "sno", label: (<span style={{ display: 'flex', justifyContent: 'start' }}>{t("tbl_head_s_no")}</span>) },
      { id: "medicine_name", label: (<span style={{ display: 'flex', justifyContent: '' }}>{t("tbl_medicine_name")}</span>) },
      { id: "amount", label: (<span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{`${t("tbl_head_fees")} `}</span>) },
      { id: "quantity", label: (<span style={{ display: 'flex', justifyContent: 'center' }}>{t("qty")}</span>) },
      { id: "commission_percentage", label: (<span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{t("tbl_Incentive")}</span>) },
      { id: "tomShare", label: (<span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{t("tbl_head_tomshare")}</span>) },
      { id: "pharmacyShare", label: (<span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{`${t("tbl_head_income")} `}</span>) },
    ])
    var searchData = [];
    var searchData1 = [];
    this.state.tableData.filter((data) => {
      const s = this.state.search ? this.state.search.toLowerCase() : null;
      const matchesSearch = !s ||
        (data.name && data.name.toLowerCase().includes(s)) ||
        (data.customer && data.customer.toLowerCase().includes(s)) ||
        (data.doctorName && data.doctorName.toLowerCase().includes(s)) ||
        (data.medicine_name && data.medicine_name.toLowerCase().includes(s)) ||
        (data.date && data.date.toString().toLowerCase().includes(s));
      if (matchesSearch) {
        if (this.state.isMedListPage) {
          searchData.push({
            medicine_name: (<span style={{ display: 'flex', justifyContent: (localStorage.pharmacy_language == 'ar' ? 'end' : 'start') }}>{data.medicine_name}</span>),
            // amount: (<p className="ccRev">{formatMoney(data.amount)}</p>),
            amount: (<p className={`${this.props.i18n.language == 'ar' ? "" : "ccRev"} `}>{formatMoney(data.amount)}</p>),
            quantity: (<span style={{ display: 'flex', justifyContent: 'center' }}>{data.quantity}</span>),
            commission_percentage: <span style={{ display: 'flex', justifyContent: 'center' }}>{data.commission_percentage} %</span>,
            // tomShare: (<p className="ccRev">{formatMoney(data.tomShare)}</p>),
            tomShare: (<p className={`${this.props.i18n.language == 'ar' ? "" : "ccRev"} `}>{formatMoney(data.tomShare)}</p>),
            // pharmacyShare: (<p className="ccRev">{formatMoney(data.pharmacyShare)}</p>),
            pharmacyShare: (<p className={`${this.props.i18n.language == 'ar' ? "" : "ccRev"} `}>{formatMoney(data.pharmacyShare)}</p>),
            id: data.id
          })
        
        } else {
          searchData.push({
            payment_date: (<span style={{ display: 'flex', justifyContent: 'center' }}>{dateFormat(data.payment_date, "d-mmm-yy")}</span>),
            name: (<span style={{
              display: 'flex', justifyContent: (localStorage.pharmacy_language == 'ar' ? 'space-between' : 'space-between'), flexDirection: (localStorage.pharmacy_language == 'ar' ? 'row-reverse' : '')
            }}><p style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', margin: '0' }}>{data.name}</p>
              {/* <img src={more} className="tableeye_icon" onClick={(e) => { e.stopPropagation(); this.modelopen("view", data.id); }} /></span>), */}
              <img src={more} className={`${this.props.i18n.language == 'ar' ? "arabTable" : "tableeye_icon"}`} onClick={(e) => { e.stopPropagation(); this.modelopen("view", data.id); }} /></span>),
            unit: (<span style={{ display: 'flex', justifyContent: 'center' }}>{data.unit}</span>),
            // fee: (<p className="ccRev">{formatMoney(data.fee)}</p>),
            // tomShare: (<p className="ccRev">{formatMoney(data.tomShare)}</p>),
            // inCome: (<p className="ccRev">{formatMoney(data.inCome)}</p>),
            fee: (<p className={`${this.props.i18n.language == 'ar' ? "" : "ccRev"} `}>{formatMoney(data.fee)}</p>),
            tomShare: (<p className={`${this.props.i18n.language == 'ar' ? "" : "ccRev"} `}>{formatMoney(data.tomShare)}</p>),
            inCome: (<p className={`${this.props.i18n.language == 'ar' ? "" : "ccRev"} `}>{formatMoney(data.inCome)}</p>),
            id: (<span style={{ display: 'flex', justifyContent: 'center' }}>{data.id}</span>),
          })
          searchData1.push({
            payment_date: data.payment_date,
            name: data.name,
            unit: data.unit,
            fee: data.fee,
            tomShare: data.tomShare,
            inCome: data.inCome,

          })
        }

      }
      // else if (
      //   (data.customer !== null &&
      //     data.customer
      //       .toLowerCase()         
      //       .includes(this.state.search.toLowerCase())) ||
      //   (data.doctorName != null &&    
      //     data.doctorName
      //       .toLowerCase()    
      //       .includes(this.state.search.toLowerCase())) ||
      //   (data.date != null &&
      //     data.date
      //       .toString()      
      //       .toLowerCase()   
      //       .includes(this.state.search.toString()))   
      // ) {
      //   searchData.push({
      // orderId:data.orderId,
      // customer: (
      //   <> <span>{`${data.customer}`}</span><img src={more}
      //     className="tableeye_icon"
      //     onClick={() => {
      //       this.modelopen("view", data.prescription_id);
      //     }}
      //   /></>                 
      // ),
      // doctorName: data.doctorName,
      // date: data.date,
      // totalCharge: data.totalCharge,
      // total: data.total,
      // action: (
      //   <img src={more}
      //     className="tableeye_icon"
      //     onClick={() => {
      //       this.modelopen("view", data.prescription_id);
      //     }}
      //   />
      // ),
      // id: data.id,
      // });
      // }
    });

    // EXCEL FUNCTION
    var multiDataSetbody = [];
    this.state.tableData.map((xldata, index) => {
      // debugger
      if (index % 2 !== 0) {
        if (this.state.medListID) {
          multiDataSetbody.push([
            { value: index + 1, style: { alignment: { horizontal: "center" } } },
            { value: xldata.medicine_name },
            { value: xldata.amount },
            { value: xldata.quantity },
            { value: xldata.commission_percentage },
            { value: xldata.tomShare },
            {
              value: xldata.pharmacyShare,
              style: { alignment: { horizontal: "center" } },
            },
          ]);
        } else {
          multiDataSetbody.push([
            { value: index + 1, style: { alignment: { horizontal: "center" } } },
            { value: xldata.payment_date },
            { value: xldata.name },
            { value: xldata.unit },
            { value: xldata.fee },
            { value: xldata.tomShare },
            {
              value: xldata.inCome,
              style: { alignment: { horizontal: "center" } },
            },
          ]);
        }

      } else {
        if (this.state.medListID) {
          multiDataSetbody.push([
            {
              value: index + 1, style: {
                alignment: { horizontal: "center" },
                fill: { patternType: "solid", fgColor: { rgb: "e2e0e0" } },
              },
            },
            {
              value: xldata.medicine_name,
              style: {
                fill: { patternType: "solid", fgColor: { rgb: "e2e0e0" } },
              },
            },
            {
              value: xldata.amount,
              style: {
                fill: { patternType: "solid", fgColor: { rgb: "e2e0e0" } },
              },
            },
            {
              value: xldata.quantity,
              style: {
                fill: { patternType: "solid", fgColor: { rgb: "e2e0e0" } },
              },
            },
            {
              value: xldata.commission_percentage,
              style: {
                fill: { patternType: "solid", fgColor: { rgb: "e2e0e0" } },
              },
            },
            {
              value: xldata.tomShare,
              style: {
                fill: { patternType: "solid", fgColor: { rgb: "e2e0e0" } },
              },
            },
            {
              value: xldata.pharmacyShare,
              style: {
                alignment: { horizontal: "center" },
                fill: { patternType: "solid", fgColor: { rgb: "e2e0e0" } },
              },
            },
          ]);
        } else {
          multiDataSetbody.push([
            {
              value: index + 1, style: {
                alignment: { horizontal: "center" },
                fill: { patternType: "solid", fgColor: { rgb: "e2e0e0" } },
              },
            },
            {
              value: xldata.payment_date,
              style: {
                fill: { patternType: "solid", fgColor: { rgb: "e2e0e0" } },
              },
            },
            {
              value: xldata.name,
              style: {
                fill: { patternType: "solid", fgColor: { rgb: "e2e0e0" } },
              },
            },
            {
              value: xldata.unit,
              style: {
                fill: { patternType: "solid", fgColor: { rgb: "e2e0e0" } },
              },
            },
            {
              value: xldata.fee,
              style: {
                fill: { patternType: "solid", fgColor: { rgb: "e2e0e0" } },
              },
            },
            {
              value: xldata.tomShare,
              style: {
                fill: { patternType: "solid", fgColor: { rgb: "e2e0e0" } },
              },
            },
            {
              value: xldata.inCome,
              style: {
                alignment: { horizontal: "center" },
                fill: { patternType: "solid", fgColor: { rgb: "e2e0e0" } },
              },
            },
          ]);
        }

      }
    });
    const multiDataSet = [
      {
        columns: [
          {
            title: this.state.medListID ? "S.No" : "S.No",
            width: { wpx: 35 },
            style: {
              fill: { patternType: "solid", fgColor: { rgb: "86b149" } },
            },
          },
          {
            title: this.state.medListID ? "Medicine Name" : "Date",
            width: { wch: 20 },
            style: {
              fill: { patternType: "solid", fgColor: { rgb: "86b149" } },
            },
          },
          {
            title: this.state.medListID ? "Fee" : "Member",
            width: { wch: 20 },
            style: {
              fill: { patternType: "solid", fgColor: { rgb: "86b149" } },
            },
          },
          {
            title: this.state.medListID ? "Quantity" : "Medicine Unit",
            width: { wch: 20 },
            style: {
              fill: { patternType: "solid", fgColor: { rgb: "86b149" } },
            },
          },
          {
            title: this.state.medListID ? "Incentive (%)" : `fee (${"₹"})`,
            width: { wpx: 100 },
            style: {
              fill: { patternType: "solid", fgColor: { rgb: "86b149" } },
            },
          },
          {
            title: this.state.medListID ? `Platform Fee (${"₹"})` : `Platform Fee (${"₹"})`,
            width: { wpx: 100 },
            style: {
              fill: { patternType: "solid", fgColor: { rgb: "86b149" } },
            },
          },
          {
            title: this.state.medListID ? `Income (${"₹"})` : `Income (${"₹"})`,
            width: { wpx: 100 },
            style: {
              fill: { patternType: "solid", fgColor: { rgb: "86b149" } },
            },
          },
        ],
        data: multiDataSetbody,
      },
    ];


    return (
      <div>
        <Paper>
          <div className="uploadsmasterheader revenue_head_div">
            {/* <div className="titlerevenue">{this.state.isMedListPage ? `MEDICINE DETAILS ${this.state.medlistTitle}` : `${t("revenue_head")} ${new Date(this.state.StartDate).getMonth() == new Date(this.state.EndDate).getMonth() ? */}
            <div className="titlerevenue">{this.state.isMedListPage ? `${t('medicine_details')} ${this.state.medlistTitle}` : `${t("revenue_head")} ${new Date(this.state.StartDate).getMonth() == new Date(this.state.EndDate).getMonth() ?
              '- ' + new Date(this.state.StartDate).toLocaleDateString('en-US', { month: 'short' }).toUpperCase() + "  " + new Date(this.state.StartDate).getFullYear() % 100
              : '- ' + new Date(this.state.StartDate).toLocaleDateString('en-US', { month: 'short' }).toUpperCase() + "  " + new Date(this.state.StartDate).getFullYear() % 100 + " - " +
              new Date(this.state.EndDate).toLocaleDateString('en-US', { month: 'short' }).toUpperCase() + "  " + new Date(this.state.EndDate).getFullYear() % 100}`}</div>

            <div
              style={{
                fontSize: "14px",
                display: "flex",
                alignItems: "center",
              }}
              className="range_picker_reduce"
            >

              {/* {this.state.StartDate &&  */}
              <div className={`${this.props.i18n.language == 'ar' ? "order_3" : ""} `}>
                {/* <DateRangeSelect
                  revenueRange
                  dynalign={"dynalign"}
                  rangeDate={(item) => this.getRangeDate(item)}
                  t={t}
                  i18n={this.props.i18n}
                /> */}
                {/* {VariableStorage(this.state.StartDate)} */}
                {this.state.isMedListPage == false && this.state.isMedPage == true && DateData.item?.startDate &&
                  <Monthpicker
                    s_month={
                      this.state.idControl == 'settlementkw' || this.state.pgNav == 'settlementkw' ?
                        moment(new Date(DateData.item?.startDate)).add('year').format('YYYY-MM')

                        : moment(new Date(this.state?.startDate)).add('year').format('YYYY-MM')
                    }
                    rangeDate={(item) => this.getRangeDate(item)} />
                }

              </div>

              {/* } */}


              <ReactSVG
                src={Filter}
                style={{ marginRight: "15px", marginLeft: "15px" }}
                onClick={this.openAdvanceFilter}
                className={`${this.props.i18n.language == 'ar' ? "order_2" : ""} `}
              />

              <Search
                placeholder="Search"
                onChange={(e) => this.onSearch(e)}
                style={{ width: 150 }}
                className={`${this.props.i18n.language == 'ar' ? "order_1" : ""} mr-2 ml-2`}
              />

              <div className={`${this.props.i18n.language == 'ar' ? "order_0" : ""} icon_head`}
                style={{ direction: (localStorage.pharmacy_language == 'ar' ? 'rtl' : '') }}>
                <PDF
                  weekMonthYearData={this.state.tableData}
                  headRows={headRows}
                  filename={"Revenue Details"}
                  headingTitle={'Revenue Details'}
                  type={"Revenue"}
                    HeadingButton={[{
                    revenueTotal: this.state.revenueTotal.toFixed(2),
                    revenueTomshare: this.state.revenueTomshare.toFixed(2),
                    revenueFee: this.state.revenueFee.toFixed(2),
                  }
                  ]}
                  lang={this.props.i18n.language}
                />
                {/* {this.state.tableData.length === 0 ? (
                <ReactSVG
                  onClick={this.Notification}
                  src={Excel}
                  style={{ marginRight: "15px" }}
                />
              ) : (
                <ExcelFile
                  filename={"Revenue_Details"}
                  element={
                    <ReactSVG src={Excel} style={{ marginRight: "15px" }} />
                  }
                >
                  <ExcelSheet dataSet={multiDataSet} name="Revenue Details" />
                </ExcelFile>
              )} */}
                {/* {this.state.tableData.length === 0 ? (
                  <ReactSVG
                    src={Excel}
                    style={{ marginRight: "15px", marginLeft: (localStorage.pharmacy_language == 'ar' ? '15px' : '') }}
                    onClick={this.Notification}
                  />
                ) : (
                  <ExcelFile
                    filename={"Revenue_Details"}
                    element={
                      <ReactSVG src={Excel} style={{ marginRight: "15px", marginLeft: (localStorage.pharmacy_language == 'ar' ? '15px' : '') }} />
                    }
                  >
                    <ExcelSheet dataSet={multiDataSet} name="Revenue_Details" />
                  </ExcelFile>
                )} */}
                <img
                  onClick={() => {
                    downloadExcel('Revenue', searchData1, heading, '', [
                      { income: '' },
                      { income: '' },
                      { income: '' },
                      { income: 'Total' },
                      { income: this.state.revenueFee.toFixed(2) },
                      { income: this.state.revenueTomshare.toFixed(2) },
                      { income: this.state.revenueTotal.toFixed(2) },
                    ])
                  }}
                  src={Excel}
                  style={{ cursor:'pointer' }}
                />

                {this.state.tableData.length === 0 ? (
                  <ReactSVG src={Print} onClick={this.Notification} />
                ) : (
                  <ReactToPrint
                    trigger={() => <ReactSVG src={Print} />}
                    content={() => this.componentRef}
                  />
                )}
                <div style={{ display: "none" }}>
                  <PrintData
                    printTableData={this.state.tableData}
                    ref={(el) => (this.componentRef = el)}
                    type={this.state.isMedListPage ? 'medlist' : 'revenue'}
                    HeadingButton={
                      [{
                        revenueTotal: this.state.revenueTotal.toFixed(2),
                        revenueTomshare: this.state.revenueTomshare.toFixed(2),
                        revenueFee: this.state.revenueFee.toFixed(2),
                      }
                      ]}
                  />
                </div>
              </div>



            </div>
          </div>

          <div className="revenue-master-table">
            {/* <div>{this.state.isMedListPage ? 1 : 2}</div> */}
            <div className="toggler mt-4" style={{ direction: (localStorage.pharmacy_language == 'ar' ? 'rtl' : '') }}>
              {this.state.isMedListPage == false &&
                <div className="switches-container">
                  <input
                    type="radio"
                    id="revenue1"
                    name="switchPlan"
                    value="revenue"
                    checked="checked"
                    onChange={this.handleRadioChange}
                  />
                  <label htmlFor="revenue1" className={this.state.toggle_Revenue}>
                    {/* Revenue */}
                    {t('revenue_with_kwd')}
                  </label>
                  <input
                    type="radio"
                    id="pharma"
                    name="switchPlan"
                    value="settlement"
                    onChange={this.handleRadioChange}
                  />
                  <label htmlFor="pharma" className={this.state.toggle_settlement}>
                    {/* Settlement */}
                    {t('settleof')}
                  </label>
                  {/* <input
                  type="radio"
                  id="tomshare"
                  name="switchPlan"
                  value="balanrec"
                  onChange={this.handleRadioChange}
                />
                <label htmlFor="tomshare" className={this.state.Togglepending}>
                  Balance Receivable
                </label> */}
                </div>}
            </div>
            <div className="allkwd_lbl" style={{
              padding: (localStorage.pharmacy_language == 'ar' ? '1rem 33px 0 33px' : '1rem 33px 0 0'),
              textAlign: (localStorage.pharmacy_language == 'ar' ? 'start' : '')
            }}>
              {/* All values in INR */}
              {t('all_values_in_kwd')}
            </div>
            {this.state.isMedListPage == true && (
              <Tablecomponent
                type="revenue"
                memberID={this.state.isMemberId}
                isonclickMember={this.state.isonclickMember}
                isHeadingButton={true}
                HeadingButton={((localStorage.pharmacy_language == 'ar') ?
                  [
                    { label: `${this.state.revenueTomshare.toFixed(2)}`, type: 'tomshare' },
                    { label: `${this.state.revenueTotal.toFixed(2)}` },
                    "",
                    "",
                    { label: `${this.state.revenueFee.toFixed(2)}` },
                    "",
                    ""
                  ] :
                  [
                    "",
                    "",
                    { label: `${this.state.revenueFee.toFixed(2)}` },
                    "",
                    "",
                    { label: `${this.state.revenueTomshare.toFixed(2)}`, type: 'tomshare' },
                    { label: `${this.state.revenueTotal.toFixed(2)}` },
                  ]
                )}
                getMemberDetails={this.getMemberDetails}
                heading={medListheading}
                rowdata={searchData}
                tableicon_align={""}
                modelopen={(e) => this.modelopen(e)}
                actionclose="close"
                EditIcon="close"
                DeleteIcon="close"
                VisibilityIcon="close"
                grandtotal="total"
                props_loading={this.state.props_loading}
                modeprop
                t={t}
                i18n={this.props.i18n}
              />
            )}

            {this.state.isMedListPage == false && (
              <>
                {" "}
                <Tablecomponent
                  type="revenue"
                  oncliking="RevenueAndSettlement"
                  memberID={this.state.isMemberId}
                  isonclickMember={this.state.isonclickMember}
                  isHeadingButton={true}
                  HeadingButton={((localStorage.pharmacy_language == 'ar') ?
                    [
                      { label: `${this.state.revenueTotal.toFixed(2)}` },
                      { label: `${this.state.revenueTomshare.toFixed(2)}`, type: 'tomshare' },
                      { label: `${this.state.revenueFee.toFixed(2)}` },
                      "",
                      "",
                      "",
                      "",
                    ] :
                    [
                      "",
                      "",
                      "",
                      "",
                      { label: `${this.state.revenueFee.toFixed(2)}` },
                      { label: `${this.state.revenueTomshare.toFixed(2)}`, type: 'tomshare' },
                      { label: `${this.state.revenueTotal.toFixed(2)}` }]
                  )}
                  getMemberDetails={this.getMemberDetails}
                  heading={heading}
                  rowdata={searchData}
                  tableicon_align={""}
                  modelopen={(e) => this.modelopen(e)}
                  startDate={this.state.StartDate}
                  EndDate={this.state.EndDate}
                  newDateGet={(e) => this.newDateGet(this.state.StartDate, this.state.EndDate)}
                  actionclose="close"
                  EditIcon="close"
                  DeleteIcon="close"
                  VisibilityIcon="close"
                  grandtotal="total"
                  props_loading={this.state.props_loading}
                  modeprop
                  t={t}
                  i18n={this.props.i18n}

                />
                {/* <div className="revenueTotal">
                  <span>
                    {" "}
                    {t("Total Income")}{" "}
                    {`${this.state.revenueTotal.toFixed(2)}`}{" "}
                    <span className="font_10">INR</span>
                  </span>
                </div> */}
              </>
            )}
          </div>

        </Paper>

        {/* {this.state.openview ? (
          <ProfileView
            open={this.state.openview}
            onClose={this.handleClose}
            xswidth={"xs"}
            profileData={this.state.profileData}
            getTableData={() => this.getTableData()}
            isFrom="revenueTable"
          />
        ) : null} */}

        {this.state.prescriptionopenview && (
          <PrescriptionDetailView
            prescriptionopenview={this.state.prescriptionopenview}
            onClose={this.handleClose}
            xswidth={"sm"}
            prescriptionEntryData={this.state.prescriptionEntryData}
            getTableData={() => this.getTableData()}
            is_from_revenue={true}
            t={t}
            i18n={this.props.i18n}
            fromData="revenuedetails"
          />
        )}

        <AdvanceFilter open={this.state.open_filter}
          onClose={this.closeAdvanceFilter}
          submitAdvanceFilter={this.submitAdvanceFilter}
          t={t}
          i18n={this.props.i18n}
        />
      </div>
    );
  }
}
export default withTranslation()(RevenueMaster);
